import { gql } from "graphql-tag";
import { PRODUCT_GROUP_FIELDS, PAGINATION, GROUP_PRODUCTS_FIELDS, PRODUCT_GROUP_PRODUCT_FIELDS, PRODUCT_GROUP_PRODUCTS_PAGINATION } from "./Fragments";
import { MANUFACTURER_FIELDS } from "@/modules/catalog/manufacturers/graphql/Fragments";
import { PAGINATION as PRODUCT_LIST_PAGINATION } from "@/modules/catalog/products/graphql/Fragments";

export const GET_PRODUCT_GROUP = gql`
    query GetProductGroups($page: Int, $limit: Int) {
        product_groups(limit:$limit, page:$page){
            ...Pagination
            data {
                ...ProductGroupFields
            }
        }
    }
    ${PRODUCT_GROUP_FIELDS},
    ${PAGINATION},
`;


export const GET_PRODUCT_GROUP_PRODUCTS = gql`
    query GetProductGroupProducts($page: Int, $limit: Int, $id: Int) {
        product_group_products(limit: $limit, page: $page, id: $id) {
            ...ProductGroupProductsPaginationFields
            data {
                ...ProductGroupProductFields
            }
        }
    }
    ${PRODUCT_GROUP_PRODUCTS_PAGINATION}
    ${PRODUCT_GROUP_PRODUCT_FIELDS}
`;

export const SEARCH_PRODUCT_GROUPS = gql`
    query SearchProductGroups($page: Int, $limit: Int, $filter: String, $search_key: String, $locale:String, $type:String) {
        search_product_groups(limit:$limit, page:$page, filter:$filter, search_key:$search_key, locale:$locale, type:$type){
            ...Pagination
            data {
                ...ProductGroupFields
            }
        }
    }
    ${PRODUCT_GROUP_FIELDS},
    ${PAGINATION},
`;

export const GET_GROUP_PRODUCTS = gql`
    query GetGroupProducts($page: Int, $limit: Int, $product_group_id: Int) {
        group_products(page: $page, limit: $limit, product_group_id: $product_group_id) {
            ...Pagination
            data {
                id
                status
                available_stock
                economic_number
                is_shop_product
                description {
                    name
                }
            }
        }
    }
    ${PRODUCT_LIST_PAGINATION}
`;

export const GET_PRODUCT_GROUP_PRICE_ASSIGNMENTS = gql`
    query GetProductGroupPriceAssignments($product_group_id: Int!) {
        product_group_price_assignments(product_group_id: $product_group_id) {
            id
            product_group_id
            price_group_id
            discount_type
            discount_value
            created_at
            price_group {
                id
                name
            }
        }
    }
`;

export default { GET_PRODUCT_GROUP, SEARCH_PRODUCT_GROUPS, GROUP_PRODUCTS_FIELDS, GET_PRODUCT_GROUP_PRICE_ASSIGNMENTS };
